import { chakra } from '@chakra-ui/react'
import { faSparkles } from '@fortawesome/pro-duotone-svg-icons'
import { faCakeCandles } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { withOrdinalSuffix } from '@/utils/helpers'

import Tippy from '@/components/UI/Tippy'

export default function AnniversaryIcon({
  years,
  includeTooltip = false,
  fontSize = '16px',
  isCurrentUser,
  displayName,
}: {
  years: number
  includeTooltip?: boolean
  fontSize?: string
  isCurrentUser: boolean
  displayName: string
}): JSX.Element | null {
  return (
    <Tippy
      content={`This week is ${isCurrentUser ? 'your' : `${displayName}'s`} ${withOrdinalSuffix(
        years
      )} Schoolhouse-versary!`}
      disabled={!includeTooltip}
    >
      <chakra.span>
        <chakra.span color="primary.solid">
          <FontAwesomeIcon icon={faCakeCandles} fontSize={fontSize} />
        </chakra.span>
        <chakra.span verticalAlign="top" lineHeight={fontSize} color="yellow.solid">
          <FontAwesomeIcon icon={faSparkles} fontSize="12px" />
        </chakra.span>
      </chakra.span>
    </Tippy>
  )
}
